import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { DropdownStateContext } from '../../DropdownStateManager';
import IconButtonWithContextMenu from '../IconButtonWithContextMenu';
import s from './ButtonWithContextMenuOnHover.scss';
var offsetModifier = [0, 0];
var HoverTrigger = function (_a) {
    var children = _a.children;
    var _b = useContext(DropdownStateContext), openDropdown = _b.openDropdown, closeDropdown = _b.closeDropdown, firstKeyInteraction = _b.firstKeyInteraction;
    return (React.createElement("div", { className: s['hover-wrapper'], onMouseEnter: openDropdown, 
        // Checking `firstKeyInteraction` here to prevent any unexpected closing of the
        // context menu due when primarily interacting with the site via keyboard
        onMouseLeave: !firstKeyInteraction ? closeDropdown : undefined }, children));
};
/**
 * Triggers the attached context menu on hover in addition to the standard onClick of other buttons with context menus.
 */
var ButtonWithContextMenuOnHover = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(IconButtonWithContextMenu, __assign({ wrapper: function (child) { return React.createElement(HoverTrigger, null, child); }, offsetModifier: offsetModifier }, rest), children));
};
ButtonWithContextMenuOnHover.displayName = 'ButtonWithContextMenuOnHover';
export default ButtonWithContextMenuOnHover;
//# sourceMappingURL=ButtonWithContextMenuOnHover.js.map